import EmptyPage from "_components/atoms/emptyView";

const MyError = ( { msg } ) => {
	return (
		<div
			style = { {
				minHeight: "calc(100vh - 104px)"
			} }
		>
			<EmptyPage customMsg = { msg } />
		</div>
	);
};

export default MyError;
